import * as actions from '@/modules/experiences'

export const fetchExperiences = async ({ dispatch, rootGetters }) => {
  if (rootGetters['fetching/isFetching']('experiences')) {
    return await rootGetters['fetching/getRequest']('experiences');
  }

  const request = actions.fetchExperiences();

  const response = await dispatch('fetching/doRequest', { id: 'experiences', request }, { root: true })

  response.data.forEach(data => dispatch('upsertExperience', data))

  return response;
}

export const fetchExperience = async ({ dispatch, rootGetters }, id) => {

  if (rootGetters['fetching/isFetching'](id)) {
    return await rootGetters['fetching/getRequest'](id);
  }

  const request = actions.fetchExperience(id);

  const response = await dispatch('fetching/doRequest', { id, request }, { root: true })

  dispatch('upsertExperience', response.data)

  return response;
}

export const upsertExperience = async ({ commit }, data) => {

  const { ...experience } = data;

  commit('upsertOne', experience)
}

export default {
  fetchExperiences,
  fetchExperience,
  upsertExperience
}
